import {
  IRawVariant,
  IVariant,
  TOnboardingDynamicConfig,
  TPaywallDynamicConfig,
} from 'models/variant.model'

import { Language } from 'root-constants/common'

export const getVariantFromRawVariant = (
  rawVariant: IRawVariant,
): IVariant => ({
  cohort: rawVariant.cohort_id,
  parentCohort: rawVariant.parent_cohort_id,
  facebookPixelIds: rawVariant.facebook_pixel_ids,
  googleTagManagerId: rawVariant.google_analytics_id,
  googleAdsConversions: rawVariant.google_ads_conversions,
  tiktokPixelId: rawVariant.tiktok_pixel_id,
  snapPixelId: rawVariant.snap_pixel_id,
  applovinPixelId: rawVariant.applovin_pixel_id,
  growthBookExperiments: rawVariant.optimize_map,
  growthBookDefaultValues: rawVariant.optimize_experiments,
  hasCancelOffer: rawVariant.has_cancel_offer,
  hasInAppOffer: rawVariant.has_inapp_offer,
  hasUpsellOffer: rawVariant.has_upsell_offer,
  steps: rawVariant.steps.map((step) => ({
    id: step.page_id,
    isQuestion: step.is_question,
    isSubscriptions: step.is_subscriptions,
    isPayment: step.is_payment,
    isUpsell: step.is_upsell,
    isSkippable: step.is_skippable,
    hasHeader: step.has_header,
    hasProgressBar: step.has_progressbar,
    pageType: step.page_type?.[0] ?? '',
    onboardingDynamicConfig: step.onboarding_configs
      ? (Object.keys(step.onboarding_configs) as Language[]).reduce(
          (acc, key) => {
            return {
              ...acc,
              [key]: {
                optionType: step.onboarding_configs?.[key].option_type,
                customPageId: step.onboarding_configs?.[key].page_id_to_mobile,
                title: step.onboarding_configs?.[key].title,
                subtitle: step.onboarding_configs?.[key].subtitle,
                buttonText: step.onboarding_configs?.[key].button_text,
                imageUrls: step.onboarding_configs?.[key].image_urls,
                pageTexts: step.onboarding_configs?.[key].page_texts,
                personalization: step.onboarding_configs?.[key].personalization,
                optionData: step.onboarding_configs?.[key].option_data?.map(
                  (data) => ({
                    id: data.id,
                    value: data.value,
                    text: data.block_text,
                    additionalText: data.additional_block_text,
                    imageUrl: data.image_url,
                    imageWidth: data.image_width,
                    imageHeight: data.image_height,
                    nextPageId: data.next_page_id,
                  }),
                ),
              },
            }
          },
          {} as TOnboardingDynamicConfig,
        )
      : null,
    paywallDynamicConfig: step.paywall_configs
      ? (Object.keys(step.paywall_configs) as Language[]).reduce((acc, key) => {
          return {
            ...acc,
            [key]: {
              title: step.paywall_configs?.[key].title,
              subtitle: step.paywall_configs?.[key].subtitle,
              buttonText: step.paywall_configs?.[key].button_text,
              subscriptionBlockTitle:
                step.paywall_configs?.[key].subscription_block_title,
              subscriptionBlockType:
                step.paywall_configs?.[key].subscription_block_type,
              benefitsBlockTitle:
                step.paywall_configs?.[key].benefits_block_title,
              benefits: step.paywall_configs?.[key].benefits?.map((data) => ({
                id: data.id,
                text: data.block_text,
              })),
              customerReviewsTitle:
                step.paywall_configs?.[key].customer_reviews_title,
              customerReviews: step.paywall_configs?.[
                key
              ].customer_reviews?.map((data) => ({
                id: data.id,
                title: data.title,
                subtitle: data.subtitle,
                author: data.author,
                shortReview: data.short_review,
                review: data.review,
                imageUrl: data.image_url,
              })),
              personalization: step.paywall_configs?.[key].personalization,
            },
          }
        }, {} as TPaywallDynamicConfig)
      : null,
  })),
})
